import type CycleCompareSymptoms from '../../../models/CycleCompareSymptomsModel';
import type IsoDate from '../../../models/IsoDate';
import { requestAndParse, requestSuccessful } from '../request';

const getStudentCycleCompareSymptoms = async (
    studentId: number,
    cycleStart: IsoDate,
) => {
    const route = 'charts/get-student-cycle-compare-symptoms';
    const payload = { studentId, cycleStart };

    const response = await requestAndParse(route, payload, 'GET');

    const cycleCompareSymptoms = (response.body?.cycleCompareSymptoms ??
        {}) as CycleCompareSymptoms;
    const algorithm = (response.body?.algorithm ?? 'st') as 'st' | 'marquette';

    return {
        cycleCompareSymptoms,
        algorithm,
        success: requestSuccessful(response),
        error: response.body?.message as string | undefined,
    };
};

export default getStudentCycleCompareSymptoms;
